{
  "title": "Mezon monitoringi",
  "tabs": {
    "label": "Bo'limlar",
    "events": "Voqealar",
    "settings": "Ovoz sozlamalari"
  },
  "levels": {
    "normal": "Normal holatda",
    "m1": "M-1 (Potensial xavfli)",
    "m2": "M-2 (Avariya oldi)",
    "m1Full": "M-1 (Potensial xavfli) holati",
    "m2Full": "M-2 (Avariya oldi) holati"
  },
  "kpi": {
    "open": "Faol hodisalar",
    "unacknowledged": "Tasdiqlanmagan",
    "m1": "M-1 hodisalar",
    "m2": "M-2 hodisalar",
    "unit": "{{count}} ta"
  },
  "filters": {
    "status": "Holat",
    "level": "Daraja",
    "unack": "Faqat tasdiqlanmaganlar",
    "search": "Qidirish",
    "total": "Jami: {{count}} ta",
    "reset": "Filtrni tozalash"
  },
  "status": {
    "open": "Faol",
    "closed": "Yopilgan",
    "all": "Barchasi"
  },
  "level": {
    "all": "Barcha darajalar",
    "m1": "M-1",
    "m2": "M-2"
  },
  "columns": {
    "level": "Daraja",
    "indicator": "Ko'rsatkich",
    "device": "Qurilma",
    "startedAt": "Boshlangan",
    "duration": "Davomiyligi",
    "peak": "Pik qiymat",
    "threshold": "Chegara",
    "state": "Holat",
    "ack": "Tasdiqladi"
  },
  "state": {
    "open": "Faol",
    "closed": "Yopilgan",
    "endedAt": "Tugagan: {{time}}"
  },
  "ack": {
    "button": "Tasdiqlash",
    "done": "Hodisa tasdiqlandi",
    "at": "{{time}} da"
  },
  "duration": {
    "d": "{{count}} kun",
    "h": "{{count}} soat",
    "m": "{{count}} daq",
    "running": "davom etmoqda"
  },
  "empty": {
    "openTitle": "Faol hodisalar yo'q",
    "openText": "Nazoratdagi barcha ko'rsatkichlar me'yorda.",
    "title": "Hodisalar topilmadi",
    "text": "Tanlangan filtr bo'yicha hodisa yo'q."
  },
  "settings": {
    "m1Title": "Mezon 1 ovoz sozlamasi",
    "m2Title": "Mezon 2 ovoz sozlamasi",
    "sound": "Ovoz turini tanlang",
    "sounds": {
      "signal_deep": "Signal deep",
      "siren": "Sirena ovozi"
    },
    "configure": "Ogohlantirishni sozlang",
    "screenTitle": "{{level}} ogohlantirish (ekranda)",
    "screenText": "Agar siz o’chirib qo’ysangiz ekranda chiqmaydi",
    "playTitle": "{{level}} ogohlantirish (ovoz)",
    "playText": "Agar siz o’chirib qo’ysangiz ovozi chiqmaydi",
    "test": "Tekshirish",
    "repeat": "Takrorlash soni",
    "repeatSuffix": "marotaba",
    "duration": "Davomiyligi sekund",
    "durationSuffix": "sekund",
    "repeatError": "1 dan 100 gacha butun son",
    "durationError": "1 dan 3600 gacha butun son",
    "save": "Saqlash",
    "cancel": "Bekor qilish",
    "saved": "Sozlamalar saqlandi",
    "updatedBy": "Oxirgi o'zgartirish: {{name}}, {{time}}",
    "hint": "Sozlamalar obyektning barcha foydalanuvchilari uchun amal qiladi"
  },
  "bell": {
    "label": "Ogohlantirishlar",
    "count": "{{count}} ta tasdiqlanmagan hodisa"
  },
  "banner": {
    "region": "Faol ogohlantirishlar",
    "title": "{{level}}: {{indicator}} — {{value}}",
    "started": "Boshlandi: {{time}}",
    "threshold": "Chegara: {{value}}",
    "view": "Ko'rish",
    "ack": "Tasdiqlash",
    "close": "Yopish",
    "mute": "Ovozni o'chirish",
    "enableSound": "Ovozni yoqish",
    "blocked": "Brauzer ovozni to'xtatib turibdi"
  },
  "error": {
    "load": "Ma'lumotlarni yuklab bo'lmadi",
    "retry": "Qayta urinish",
    "generic": "Xatolik yuz berdi"
  }
}
